interface IconStarsProps {
    width?: number;
    height?: number;
    variant?: "large" | "small";
}

export const IconStars = ({ width = 24, height = 24, variant = "large" }: IconStarsProps) => {
    if (variant === "small") {
        return (
            <svg width={width ?? 11} height={height ?? 11} viewBox="0 0 13 13" fill="none">
                <path
                    d="M13.1125 7.31152C10.9669 6.59688 9.82558 5.9991 9.14474 5.05113C8.46391 4.10316 8.26202 2.83068 8.27019 0.569198C7.55555 2.71481 6.95778 3.85614 6.00735 4.53657C5.05938 5.2174 3.7869 5.41929 1.5237 5.41084C3.67103 6.12576 4.79367 6.80666 5.47696 7.75503C6.15739 8.70546 6.37796 9.89481 6.36951 12.158C7.08443 10.0107 7.66985 8.94479 8.61782 8.26396C9.5662 7.58067 10.851 7.30335 13.1125 7.31152Z"
                    fill="white"
                />
            </svg>
        );
    }

    return (
        <svg width={width ?? 22} height={height ?? 22} viewBox="0 0 22 22" fill="none">
            <path
                d="M20.9726 12.6124C17.2714 11.3796 15.3026 10.3484 14.1282 8.71319C12.9538 7.07794 12.6055 4.88292 12.6196 0.98186C11.3868 4.68305 10.3557 6.65183 8.7162 7.82557C7.08094 9.00001 4.88593 9.34827 0.981904 9.33369C4.68605 10.5669 6.62261 11.7415 7.80128 13.3774C8.97502 15.0169 9.3555 17.0685 9.34093 20.9726C10.5742 17.2684 11.584 15.4298 13.2193 14.2553C14.8552 13.0767 17.0715 12.5983 20.9726 12.6124Z"
                fill="white"
            />
        </svg>
    );
};